import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../context/AuthContext";
import { getActiveWorkspaceSlug } from "./workspaceStorage";
import { getSessionRoleIndicator } from "./sessionRoleIndicator";
import { isPartnerConsolePath } from "./partnerPortal";
import { isPlatformConsolePath } from "../pages/Platform/XprobaseConsole/platformConsoleRoutes";

/**
 * Mantém `?ws=` na URL nas abas partner/platform em atendimento.
 * Assim F5 / reload reinicia a aba no mesmo workspace mesmo após navegação SPA
 * (chat → settings → etc.) ter trocado o path.
 *
 * O menu/Sidebar deve preferir `withActiveWorkspaceQuery` nos links para evitar
 * o bounce `/rota` → `/rota?ws=` que remonta a página no primeiro clique.
 */
export function useSyncWorkspaceQueryParam() {
  const location = useLocation();
  const navigate = useNavigate();
  const { userData } = useAuthContext() || {};

  useEffect(() => {
    const role = getSessionRoleIndicator(userData);
    if (!role) return;
    if (isPartnerConsolePath(location.pathname) || isPlatformConsolePath(location.pathname)) return;

    const slug = getActiveWorkspaceSlug();
    if (!slug) return;

    const params = new URLSearchParams(location.search || "");
    if (params.get("ws") === slug) return;

    params.set("ws", slug);
    const qs = params.toString();
    navigate(
      {
        pathname: location.pathname,
        search: qs ? `?${qs}` : "",
        hash: location.hash || "",
      },
      { replace: true }
    );
  }, [userData, location.pathname, location.search, location.hash, navigate]);
}
